import React from "react";
import OwnRoute from "./routes/OwnRoute";
function App() {
  return (
    <div className="ipay-ui-app">
      <OwnRoute/>
    </div>
  );
}

export default App;
